/* eslint-disable no-unused-vars */
import BaseService from './base.service'
import { ENDPOINT } from '~/api/endpoint'

class PhoneBuyService extends BaseService {
  constructor(option) {
    super(option)
    return this
  }

  /* Danh sách bệnh nhân */
  getPhoneBuySortCondition() {
    return this.http.get(ENDPOINT.PHONEBUY_SORT)
      .then(res => res.data.data)
  }

  /* Danh sách bệnh nhân */
  getPhoneBuySearchCondition() {
    return this.http.get(ENDPOINT.PHONEBUY_SEARCH)
      .then(res => res.data.data)
  }

  /* Danh sách vị thuốc */
  getPhoneBuys(params) {
    return this.http.get(ENDPOINT.PHONEBUYS, { params })
      .then(res => res.data.data)
  }

  /* Chi tiết vị thuốc */
  getPhoneBuy(PhoneBuyId) {
    return this.http.get(ENDPOINT.PHONEBUY_DETAIL.replace('{id}', PhoneBuyId))
      .then(res => res.data.data)
  }

  /* Tạo thông tin bài thuốc */
  createPhoneBuy(data) {
    return this.http.post(ENDPOINT.CREATE_PHONEBUY, { data })
      .then(res => res.data.data)
  }
  /* Tạo thông tin bài thuốc */
  updatePhoneBuy(PhoneBuyId, data) {
    return this.http.put(ENDPOINT.PHONEBUY_DETAIL.replace('{id}', PhoneBuyId), { data })
      .then(res => res.data.data)
  }

  /* Chi tiết vị thuốc */
  deletePhoneBuyByID(PhoneBuyId) {
    return this.http.delete(ENDPOINT.UPDATE_PHONEBUY.replace('{id}', PhoneBuyId))
      .then(res => res.data.data)
  }

  uploadExcelFile(excelFile) {
    return this.http.post(ENDPOINT.UPLOAD_PHONEBUY, excelFile)
    .then(data => data.data)
  }
}

export default new PhoneBuyService({ auth: true })
